var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<button class=\"btn btn-blue bill-btn\" ng-click=\"printItemClick(payment.template)\"> <i class=\"icon-15\"></i><span class=\"blue-btn\">{{'ACTIONS.PRINT' | translate}}</span> </button>";
ngModule.run(["$templateCache",function(c){c.put("paymentStatus/templates/printTemplate.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentStatus/templates/printTemplate.html
 ** module id = 568
 ** module chunks = 1
 **/